import { useContentfulContentTypeEntry } from '@order/Contentful';
import { useLocalizationContext } from '@order/Localization';

/**
 * Returns contentful data for 'Account Deletion'.
 */
export const useAccountDeletionContentfulData = () => {
  const { t } = useLocalizationContext();

  const { data: contentfulData, fetching: isLoadingContentfulData } =
    useContentfulContentTypeEntry<AccountDeletionContentfulData>({
      contentType: ACCOUNT_DELETION_CONTENTFUL_ID,
      include: 2,
    });

  return {
    isLoadingContentfulData,
    body: contentfulData?.fields?.step2 ?? t('account.delete.body'),
  };
};

// ─── Constants ────────────────────────────────────────────────────

const ACCOUNT_DELETION_CONTENTFUL_ID = 'accountAccountDeletion';

// ─── Types ────────────────────────────────────────────────────────

type AccountDeletionContentfulData = Readonly<{
  step2?: string;
}>;
